import Toastify from 'toastify-js'

const DEFAULT_INFO_TEXT = 'Oops. Something went wrong... Try again later.';

function infoMessage(text, cssClass = 'info') {
    Toastify({
        backgroundColor: '#ffffff',
        className: cssClass,
        text: text || DEFAULT_INFO_TEXT,
        duration: 3500,
        close: true,
        stopOnFocus: true,
        onClick: function () {
        } // Callback after click
    }).showToast();
}

export {infoMessage};
